// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8IUMF","barOutput":"styles_barOutput__IZAxy","outputBig":"styles_outputBig__cIY1K","noteText":"styles_noteText__7FBH5"};